import Loadable from '../../../components/loadable';

export default Loadable(() =>
  import(/* webpackChunkName: "layout-business-subheader" */ './index')
);
